import React, { useState } from 'react';
import { CSVLink } from 'react-csv';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// external libraries
import moment from 'moment';
// Utils and error handlers
import { handleCatchError } from 'utils/handleErrors';
// API calls
import { getUserAccounts } from '../../views-admin/api/Api-admin';

const { FormatMoney } = require('format-money-js');

const fmDecimal = new FormatMoney({
  decimals: 2,
  symbol: '$',
});
const UsersCSV = ({ total }) => {
  // console.log('total de usuarios:', total);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [readyToDownload, setReadyToDownload] = useState(false);
  const today = moment().format('DD/MM/YY');

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await getUserAccounts(1, total);
      if (response.total_items !== undefined) {
        setUsers(response.data);
        setReadyToDownload(true);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setIsLoading(false);
    }
  };
  const csvData = users.map((user) => ({
    ...user, // todos los campos originales del user
    id: user.crm_user_id,
    name: user.legal_name.toUpperCase(),
    date: moment(user.created).format('DD-MM-YY'),
    // time: user.creation_date.slice(11, 16),
    status: user.is_active ? 'ACTIVA' : 'INACTIVA',
    balance: fmDecimal.from(user.current_balance, { symbol: '$' }),
  }));
  const headers = [
    { label: 'Ingreso', key: 'date' },
    { label: 'ID', key: 'id' },
    { label: 'Nombre', key: 'name' },
    { label: 'RFC', key: 'tax_id' },
    { label: 'Email', key: 'email' },
    { label: 'Saldo', key: 'balance' },
    { label: 'Vendedor', key: 'seller' },
    { label: 'Tipo', key: 'customer_type' },
    { label: 'Estado', key: 'status' },
    { label: 'Tarifario', key: 'rates_list' },
  ];
  return (
    <>
      {!readyToDownload ? (
        <button type="button" className="btn btn-primary" onClick={fetchData} disabled={isLoading} style={{ height: '36px' }}>
          <span>
            <CsLineIcons icon="download" size="15" className="mb-1" /> {isLoading ? 'Creando archivo…' : 'Todos los usuarios'}
          </span>
        </button>
      ) : (
        <CSVLink data={csvData} headers={headers} className="btn btn-primary" filename={`Usuarios(${today}).csv`} target="_blank" style={{ height: '36px' }}>
          <span>
            <CsLineIcons icon="download" size="15" className="mb-1" /> Descargar CSV
          </span>
        </CSVLink>
      )}
    </>
  );
};

export default UsersCSV;
